import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.css';
import './assets/scss/index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ProductProvider from "./store/ProductProvider";
import { initActivityTracker } from "./services/ActivityTracker";
import { initClarity, syncClarityIdentity } from "./services/clarityService";

initActivityTracker();
initClarity();
syncClarityIdentity();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<GoogleOAuthProvider clientId='134181601889-g1ma1eehv4rv82qo1esmkughkaf5de1k.apps.googleusercontent.com'>
		<ProductProvider>
			<App />
		</ProductProvider>
	</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
